import BookingCollectionDeleteDesktop from './BookingCollectionDeleteDesktop';

export default BookingCollectionDeleteDesktop;
